import React from 'react';
import PropTypes from 'prop-types';
import EmptyResults from '../EmptyResults';
import BudgetDoughnut from './BudgetDoughnut';
import DistributionChart from './DistributionChart';
import StatisticsTable from './StatisticsTable';
import DistributionTable from './DistributionTable';

function OpenBudgetQuestionResults(props) {
  const { question, hasResponses } = props;
  const { showDataTable, data } = question;
  const { datasets } = data;
  const isEmpty = datasets.every(({ counts }) => counts.every((count) => count === 0));

  return (
    <div>
      {isEmpty ? (
        <EmptyResults hasResponses={hasResponses} />
      ) : (
        <div className="engage-results-open-budget">
          <BudgetDoughnut question={question} />
          <DistributionChart question={question} />
          {showDataTable && (
            <>
              <StatisticsTable question={question} />
              <DistributionTable question={question} />
            </>
          )}
        </div>
      )}
    </div>
  );
}

OpenBudgetQuestionResults.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    showDataTable: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      averages: PropTypes.shape({
        labels: PropTypes.arrayOf(PropTypes.string),
        values: PropTypes.arrayOf(PropTypes.number),
        percentages: PropTypes.arrayOf(PropTypes.number),
      }),
      datasets: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          labels: PropTypes.arrayOf(PropTypes.string),
          counts: PropTypes.arrayOf(PropTypes.number),
          percentages: PropTypes.arrayOf(PropTypes.number),
          statistics: PropTypes.shape({
            min: PropTypes.number,
            max: PropTypes.number,
            median: PropTypes.number,
            mean: PropTypes.number,
            stdDev: PropTypes.number,
            meanDiff: PropTypes.number,
            comparisonValueLabel: PropTypes.string,
            comparisonValue: PropTypes.number,
            mode: PropTypes.number,
          }),
        })
      ),
    }),
  }).isRequired,
  hasResponses: PropTypes.bool.isRequired,
};

export default OpenBudgetQuestionResults;
